import React from 'react'
import { Link } from 'react-router-dom'
import './homeDetails.css'



const homeDetails = ({imageSrc, title, content, style, link}) => {
  return <>
    <div className='homeDetails__main' style={style}>
        <div className='homeDetails__i'>
            <img className='homeDetails__image' src={imageSrc} alt="" />
        </div>
        <div className='homeDetails__content'>
            <h1 className='homeDetails__content-h1'>{title}</h1>
            <p className='homeDetails__content-para'>{content}</p>
            <p className='homeDetails__content-para2'>See our safari page<Link className='link' to='#'>here.</Link> </p>
        </div>
    </div>
  </>
}

export default homeDetails